import { createAction } from '@ngrx/store';

export class MemoryPhaseActions {
	public static finishSuccess = createAction('[MemoryPhase] Finish Success');
}
